module.exports = __webpack_public_path__ + "static/media/Portrait-10251.1ffeceda.jpg";